module.exports = __webpack_public_path__ + "img/store-support.9f933d2f.png";